<template>
    <div>
      <!-- 主编辑资料弹窗 -->
      <el-dialog
        :visible.sync="localVisible"
        width="400px"
        :show-close="false"
        :close-on-click-modal="true"
        :append-to-body="true"
        :modal-append-to-body="true"
        custom-class="profile-dialog"
        v-if="!showPhoneChangeDialog && !showWechatChangeDialog && !showPasswordChangeDialog"
      >
        <div class="profile-container">
          <!-- 头像上传部分 -->
          <div class="avatar-section">
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.avatar" :src="form.avatar" class="avatar">
              <i v-else class="el-icon-edit avatar-edit-icon"></i>
            </el-upload>
          </div>
    
          <!-- 表单部分 -->
          <div class="form-fields">
            <div class="form-item">
              <div class="label">微信号</div>
              <div class="input-container">
                <input v-model="form.wechat" class="custom-input" />
                <span class="arrow-icon" @click="showWechatChangeDialog = true">></span>
              </div>
            </div>
            
            <div class="form-item">
              <div class="label">手机号</div>
              <div class="input-container">
                <input v-model="form.phone" class="custom-input" disabled />
                <span class="arrow-icon" @click="showPhoneChangeDialog = true">></span>
              </div>
            </div>
            
            <div class="form-item">
              <div class="label">密码</div>
              <div class="input-container">
                <input type="password" value="****************" class="custom-input" disabled />
                <span class="arrow-icon" @click="showPasswordChangeDialog = true">></span>
              </div>
            </div>
          </div>
    
          <!-- 按钮部分 -->
          <div class="dialog-footer">
            <button class="confirm-btn" @click="handleSubmit">确认</button>
            <button class="cancel-btn" @click="handleCancel">取消</button>
          </div>
        </div>
      </el-dialog>

      <!-- 修改手机号弹窗 -->
      <el-dialog
        :visible.sync="showPhoneChangeDialog"
        width="400px"
        :show-close="false"
        :close-on-click-modal="true"
        :append-to-body="true"
        :modal-append-to-body="true"
        custom-class="profile-dialog"
        @close="localVisible = true"
      >
        <div class="profile-container">
          <div class="change-title">换绑手机号</div>
          
          <div class="form-fields">
            <!-- 原手机号 -->
            <div class="form-item">
              <div class="label">原手机号</div>
              <div class="phone-input-container">
                <input v-model="phoneForm.oldPhone" class="custom-input" placeholder="请输入原手机号" />
                <button class="send-code-btn" @click="sendCode('old')">发送验证码</button>
              </div>
            </div>
            
            <!-- 验证码 -->
            <div class="form-item">
              <div class="label">验证码</div>
              <div class="input-container">
                <input v-model="phoneForm.oldCode" class="custom-input" placeholder="请输入验证码" />
              </div>
            </div>
            
            <!-- 新手机号 -->
            <div class="form-item">
              <div class="label">新手机号</div>
              <div class="phone-input-container">
                <input v-model="phoneForm.newPhone" class="custom-input" placeholder="请输入新手机号" />
                <button class="send-code-btn" @click="sendCode('new')">发送验证码</button>
              </div>
            </div>
            
            <!-- 验证码 -->
            <div class="form-item">
              <div class="label">验证码</div>
              <div class="input-container">
                <input v-model="phoneForm.newCode" class="custom-input" placeholder="请输入验证码" />
              </div>
            </div>
          </div>
          
          <!-- 按钮部分 -->
          <div class="dialog-footer">
            <button class="confirm-btn" @click="handleChangePhone">确认</button>
            <button class="cancel-btn" @click="showPhoneChangeDialog = false">取消</button>
          </div>
        </div>
      </el-dialog>

      <!-- 添加微信号绑定弹窗 -->
      <el-dialog
        :visible.sync="showWechatChangeDialog"
        width="400px"
        :show-close="true"
        :close-on-click-modal="true"
        :append-to-body="true"
        :modal-append-to-body="true"
        custom-class="profile-dialog"
        @close="localVisible = true"
      >
        <div class="profile-container">
          <div class="close-icon" @click="showWechatChangeDialog = false">
            <span class="el-icon-close"></span>
          </div>
          
          <div class="change-title">绑定微信号</div>
          
          <div class="wechat-hint-text">使用微信扫一扫下方二维码</div>
          
          <div class="qrcode-container">
            <!-- 这里使用的是渐变色二维码，您需要提供实际的二维码或使用第三方库生成 -->
            <img src="data:image/png;base64,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" class="qrcode" />
          </div>
          
          <div class="wechat-hint-text bottom-hint">下次扫码登录更便捷</div>
        </div>
      </el-dialog>

      <!-- 添加密码修改弹窗 -->
      <el-dialog
        :visible.sync="showPasswordChangeDialog"
        width="400px"
        :show-close="false"
        :close-on-click-modal="true"
        :append-to-body="true"
        :modal-append-to-body="true"
        custom-class="profile-dialog"
        @close="localVisible = true"
      >
        <div class="profile-container">
          <div class="change-title">设置新密码</div>
          
          <div class="form-fields">
            <!-- 手机号 -->
            <div class="form-item">
              <div class="label">手机号</div>
              <div class="phone-input-container">
                <input v-model="passwordForm.phone" class="custom-input" placeholder="请输入手机号" />
                <button class="send-code-btn" @click="sendPasswordCode">发送验证码</button>
              </div>
            </div>
            
            <!-- 验证码 -->
            <div class="form-item">
              <div class="label">验证码</div>
              <div class="input-container">
                <input v-model="passwordForm.code" class="custom-input" placeholder="请输入验证码" />
              </div>
            </div>
            
            <!-- 密码设置 -->
            <div class="form-item">
              <div class="label">密码设置</div>
              <div class="input-container">
                <input type="password" v-model="passwordForm.password" class="custom-input" placeholder="请输入密码" />
              </div>
            </div>
            
            <!-- 密码确认 -->
            <div class="form-item">
              <div class="label">密码确认</div>
              <div class="input-container">
                <input type="password" v-model="passwordForm.confirmPassword" class="custom-input" placeholder="再次输入密码" />
              </div>
            </div>
          </div>
          
          <!-- 按钮部分 -->
          <div class="dialog-footer">
            <button class="confirm-btn" @click="handleChangePassword">确认</button>
            <button class="cancel-btn" @click="showPasswordChangeDialog = false">取消</button>
          </div>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'UserProfileEditor',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      userInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        localVisible: this.visible,
        showPhoneChangeDialog: false,
        showWechatChangeDialog: false,
        showPasswordChangeDialog: false,
        form: {
          avatar: '',
          username: '',
          phone: '',
          wechat: ''
        },
        phoneForm: {
          oldPhone: '',
          oldCode: '',
          newPhone: '',
          newCode: ''
        },
        passwordForm: {
          phone: '',
          code: '',
          password: '',
          confirmPassword: ''
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          wechat: [
            { required: true, message: '请输入微信号', trigger: 'blur' }
          ]
        },
        uploadUrl: '/api/upload/image' // 替换为实际的上传接口
      }
    },
    watch: {
      visible(val) {
        this.localVisible = val;
      },
      localVisible(val) {
        if (!val) {
          this.showPhoneChangeDialog = false;
          this.showWechatChangeDialog = false;
          this.showPasswordChangeDialog = false;
        }
        this.$emit('update:visible', val);
      },
      userInfo: {
        handler(newVal) {
          this.initForm();
        },
        deep: true
      }
    },
    methods: {
      initForm() {
        this.form = {
          ...this.form,
          ...this.userInfo
        };
        // 初始化手机号修改表单
        this.phoneForm.oldPhone = this.form.phone || '';
        // 初始化密码修改表单
        this.passwordForm.phone = this.form.phone || '';
      },
      handleAvatarSuccess(res, file) {
        this.form.avatar = res.url
        this.$emit('avatar-updated', res.url)
      },
      beforeAvatarUpload(file) {
        // 添加文件验证逻辑
        return true
      },
      handleSubmit() {
        // 提交基本信息
        this.$emit('submit', this.form);
        this.localVisible = false;
      },
      handleCancel() {
        this.$emit('update:visible', false);
        this.$emit('cancel');
      },
      // 发送验证码
      sendCode(type) {
        const phone = type === 'old' ? this.phoneForm.oldPhone : this.phoneForm.newPhone;
        if (!phone) {
          this.$message.error('请先输入手机号');
          return;
        }
        
        // 模拟发送验证码
        this.$message.success(`验证码已发送至 ${phone}`);
        // 在实际应用中应调用API发送验证码
      },
      // 处理修改手机号
      handleChangePhone() {
        // 验证表单
        if (!this.phoneForm.oldPhone || !this.phoneForm.oldCode || 
            !this.phoneForm.newPhone || !this.phoneForm.newCode) {
          this.$message.error('请填写完整信息');
          return;
        }
        
        // 模拟API调用
        setTimeout(() => {  
          this.$message.success('手机号修改成功');
          this.form.phone = this.phoneForm.newPhone;
          this.showPhoneChangeDialog = false;
          this.localVisible = true;
        }, 1000);
      },
      // 发送密码重置验证码
      sendPasswordCode() {
        if (!this.passwordForm.phone) {
          this.$message.error('请先输入手机号');
          return;
        }
        
        // 模拟发送验证码
        this.$message.success(`验证码已发送至 ${this.passwordForm.phone}`);
        // 在实际应用中应调用API发送验证码
      },
      // 处理修改密码
      handleChangePassword() {
        // 验证表单
        if (!this.passwordForm.phone || !this.passwordForm.code) {
          this.$message.error('请填写手机号和验证码');
          return;
        }
        
        if (!this.passwordForm.password || !this.passwordForm.confirmPassword) {
          this.$message.error('请设置新密码');
          return;
        }
        
        if (this.passwordForm.password !== this.passwordForm.confirmPassword) {
          this.$message.error('两次输入的密码不一致');
          return;
        }
        
        // 模拟API调用
        setTimeout(() => {
          this.$message.success('密码修改成功');
          this.showPasswordChangeDialog = false;
          this.localVisible = true;
          
          // 重置表单
          this.passwordForm = {
            phone: '',
            code: '',
            password: '',
            confirmPassword: ''
          };
        }, 1000);
      }
    }
  }
  </script>
  
  <style scoped>
  .profile-dialog {
    border-radius: 20px !important;
    overflow: hidden;
  }
  
  ::v-deep .el-dialog {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 20px;
    overflow: hidden;
    border: 1px solid rgba(177, 110, 249, 0.2);
  }
  
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  
  ::v-deep .v-modal {
    opacity: 0.6;
  }
  
  .profile-container {
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .change-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 25px;
  }
  
  .avatar-section {
    margin-bottom: 30px;
    text-align: center;
  }
  
  .avatar-uploader {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    margin: 0 auto;
  }
  
  .avatar {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .avatar-edit-icon {
    font-size: 24px;
    color: #7EB4EB;
  }
  
  .form-fields {
    width: 100%;
    margin-bottom: 30px;
  }
  
  .form-item {
    margin-bottom: 15px;
    width: 100%;
  }
  
  .label {
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
  }
  
  .input-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(177, 110, 249, 0.2);
    padding-bottom: 10px;
  }
  
  .phone-input-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(177, 110, 249, 0.2);
    padding-bottom: 10px;
  }
  
  .custom-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 16px;
    color: #666;
    height: 30px;
  }
  
  .custom-input::placeholder {
    color: #ccc;
  }
  
  .arrow-icon {
    color: #7EB4EB;
    font-weight: bold;
    margin-left: 10px;
    cursor: pointer;
  }
  
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 20px;
  }
  
  .confirm-btn, .cancel-btn {
    width: 120px;
    height: 40px;
    border-radius: 20px;
    font-size: 16px;
    cursor: pointer;
    border: none;
    outline: none;
    transition: all 0.3s;
  }
  
  .confirm-btn {
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
  }
  
  .cancel-btn {
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid #ddd;
    color: #666;
  }
  
  .send-code-btn {
    padding: 5px 10px;
    background: linear-gradient(90deg, #7EB4EB, #B16EF9);
    color: white;
    border: none;
    border-radius: 15px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
  }
  
  .confirm-btn:hover, .cancel-btn:hover, .send-code-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  /* 添加的微信绑定样式 */
  .close-icon {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: rgba(142, 148, 251, 0.4);
    border-radius: 50%;
    color: white;
  }

  .close-icon:hover {
    background: rgba(142, 148, 251, 0.7);
  }

  .wechat-hint-text {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
    text-align: center;
  }

  .bottom-hint {
    margin-top: 20px;
    margin-bottom: 0;
    color: #999;
    font-size: 14px;
  }

  .qrcode-container {
    width: 180px;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .qrcode {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: linear-gradient(45deg, #7EB4EB, #B16EF9);
    padding: 10px;
    border-radius: 10px;
  }
  </style>